import React from 'react';

const Notification = ({ message }) => {
    return (
        <div className="alert alert-info notification" role="alert">
            {message}
        </div>
    );
};

export default Notification;